import axios from 'axios';
import axiosRetry from 'axios-retry';
import { standardRetryPolicy } from './axiosRetryPolicy';
const postArtworkChangeRequest = (baseUrl, accessToken, orderId, fulfillmentGroupId, itemId, artworkChange) => {
    const url = `/v1/orders/${orderId}/artworkchangerequests`;
    const fgcr = {
        fulfillmentGroupId,
        itemId,
        documentReferenceUrl: artworkChange.documentReferenceUrl,
        manufacturingReadyDataUrl: artworkChange.manufacturingReadyDataUrl
    };
    const acr = {
        fulfillmentGroupChangeRequests: [fgcr]
    };
    const client = axios.create();
    axiosRetry(client, standardRetryPolicy);
    return client
        .post(url, acr, {
        baseURL: baseUrl,
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    })
        .then(() => { })
        .catch(() => {
        const error = new Error('We could not create the artwork change request. Please try again.');
        error.name = 'An error has occurred.';
        throw error;
    });
};
export { postArtworkChangeRequest };
//# sourceMappingURL=wholesale-aggregation.js.map